package io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.Icons

public val Icons.CloseW500Rounded: ImageVector
    get() {
        if (_closeW500Rounded != null) {
            return _closeW500Rounded!!
        }
        _closeW500Rounded = Builder(name = "CloseW500Rounded", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp, viewportWidth = 960.0f, viewportHeight = 960.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveTo(480.0f, 543.65f)
                lineTo(287.83f, 735.83f)
                quadTo(275.15f, 748.5f, 256.0f, 748.5f)
                reflectiveQuadToRelative(-31.83f, -12.67f)
                quadTo(211.5f, 723.15f, 211.5f, 704.0f)
                reflectiveQuadToRelative(12.67f, -31.83f)
                lineTo(416.35f, 480.0f)
                lineTo(224.17f, 287.83f)
                quadTo(211.5f, 275.15f, 211.5f, 256.0f)
                reflectiveQuadToRelative(12.67f, -31.83f)
                quadTo(236.85f, 211.5f, 256.0f, 211.5f)
                reflectiveQuadToRelative(31.83f, 12.67f)
                lineTo(480.0f, 416.35f)
                lineToRelative(192.17f, -192.18f)
                quadTo(684.85f, 211.5f, 704.0f, 211.5f)
                reflectiveQuadToRelative(31.83f, 12.67f)
                quadTo(748.5f, 236.85f, 748.5f, 256.0f)
                reflectiveQuadToRelative(-12.67f, 31.83f)
                lineTo(543.65f, 480.0f)
                lineToRelative(192.18f, 192.17f)
                quadTo(748.5f, 684.85f, 748.5f, 704.0f)
                reflectiveQuadToRelative(-12.67f, 31.83f)
                quadTo(723.15f, 748.5f, 704.0f, 748.5f)
                reflectiveQuadToRelative(-31.83f, -12.67f)
                lineTo(480.0f, 543.65f)
                close()
            }
        }
        .build()
        return _closeW500Rounded!!
    }

private var _closeW500Rounded: ImageVector? = null
